/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderPostHist.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/order-post-hist";

export class AutogenModelOrderPostHist<RowType extends ModelRow> extends Endpoint<RowType, RowOrderPostHistFields> {
    constructor(ctor: RowConstructor) {
        super(endpointPath, ctor);
    }
}

export class AutogenRowOrderPostHist extends ModelRow<RowOrderPostHistFields> {
    constructor(values?: Partial<RowOrderPostHistFields>) {
        super(endpointPath, true, values);
    }
}

export interface RowOrderPostHistFields {
    attach_filename: string;
    attachment: string;
    carrier_id: string;
    comments: string;
    company_id: string;
    gps_accuracy: number;
    id: string;
    latitude: number;
    longitude: number;
    movement_id: string;
    order_id: string;
    parent_row_id: string;
    posted_by: string;
    posted_date: Date;
    posted_type: string;
    reason_code: string;
    system_added: string;
    user_name: string;
    orderhist_profile_id: string;
}

